import { render, staticRenderFns } from "./OpinianDetail.vue?vue&type=template&id=64f25ef2&scoped=true&"
import script from "./OpinianDetail.vue?vue&type=script&lang=js&"
export * from "./OpinianDetail.vue?vue&type=script&lang=js&"
import style0 from "./OpinianDetail.vue?vue&type=style&index=0&id=64f25ef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f25ef2",
  null
  
)

export default component.exports